import React from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, Button } from 'react-bootstrap';
import './NavigationBar.css';
import styled from 'styled-components';
import ima from '../img/logooo.png';
import Fade from 'react-reveal/Fade';

const Styles = styled.div`

margin-top: -7.2%;
position: sticky;
z-index: 999;
justify-content: space-between;
width: 100%;
height: 100%;
left: 0;
top: 0;

.navbar {
  background-color: #081a2f;
  opacity: 0.9;
}

.img {
  height: 42px;
  width: 42px;
  z-index: 1;
  text-align: right;
}

.text {
  font-size: 18px;
  font-style: normal;
  text-align: right;
  font-weight: bold;
  color: #000000;
  opacity: 1;
}

.te {
  color: #000000;
  font-size: 15px;
  font-weight: bold;
  background-color: #0693e3;
  border-radius: 20px;
  text-align: right;
}

.tex {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  text-align: right;
}

a, .navbar-brand, .navbar-nav .nav-link {
  color: #000000;
  &:hover {
    color: #000000;
  }
}

`;
 function web() {
  const fileName = "/תקנון-שימוש-באתר - רישוי עסקים ישראל.pdf";
  window.open(encodeURI(fileName), "_blank");
}
function scrollStep() {
  window.scrollBy({
    top: 1000,
    behavior: 'smooth'
  });
}

export const NavigationBar = () => (
  <Styles>

    <Navbar   expand="lg" className="container-1">

      <Fade bottom>
        <a href="tel:052-4816141">
          <Button className="te" variant="light">
            לייעוץ חינם ! צור קשר
          </Button>
        </a>
      </Fade>

      <Navbar.Collapse  id="basic-navbar-nav">

        <Nav className="ml-auto">

          <div className="box1">
            <Nav.Item>
              <Nav.Link>
                <Link
                  style={{ color: "white" }}
                  onClick={scrollStep}
                  className="tex"
                  to="/"
                >
                  דף הבית
                </Link>
              </Nav.Link>
            </Nav.Item>
          </div>

          <div className="box2">
            <Nav.Item>
              <Nav.Link>
                <Link
                 style={{ color: "white" }}
                  onClick={scrollStep}
                  className="tex"
                  to="/about"
                >
                  אודות
                </Link>
              </Nav.Link>
            </Nav.Item>
          </div>

          <div className="box3">
            <Nav.Item>
              <Nav.Link>
                <Link
               style={{ color: "white" }}
                  onClick={scrollStep}
                  className="tex"
                  to="/customers "
                >
                  לקוחותינו
                </Link>
              </Nav.Link>
            </Nav.Item>
          </div>

          <div className="box4">
            <Nav.Item>
              <Nav.Link>
                <Link
                style={{ color: "white" }}
                  onClick={scrollStep}
                  className="tex"
                  to="/contact "
                >
                  יצירת קשר
                </Link>
              </Nav.Link>
            </Nav.Item>
          </div>

          <div className="box5">
            <Nav.Item>
              <Nav.Link>
                <Link
        style={{ color: "white" }}
                  onClick={web}
                  className="tex"
                  to="/articles"
                >
                  תקנון האתר
                </Link>
              </Nav.Link>
            </Nav.Item>
          </div>

        </Nav>

      </Navbar.Collapse>

    </Navbar>

    <Nav bg="primary" variant="dark" className="imgg" />

    <Navbar  >

      <Nav className="ml-auto">

        <Fade bottom>
          <Navbar.Brand style={{ fontWeight: "bold" , color:"white" }}>
            רישוי עסקים ישראל&nbsp;&nbsp;
            <img
              className="aaa"
              src={ima}
              alt="logo"
              style={{ width: "100px", height: "50px" }}
            />
          </Navbar.Brand>
        </Fade>

      </Nav>

    </Navbar>

  </Styles>
);
////<Navbar bg="dark" variant="dark">

///////////  <Navbar.Toggle style={{position: "fixed" , marginRight:"auto" , textAlign:"center"}}   class="navbar-toggler navbar-toggler-right"  aria-controls="basic-navbar-nav"  />
